import { render } from "./BankImage.vue?vue&type=template&id=cedc89c4"
import script from "./BankImage.vue?vue&type=script&lang=js"
export * from "./BankImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__